import Head from "next/head";
import { make as SetWrappedPage } from "../../../src/set-wrapped12/SetWrapped12Page.bs";

export default function Wrapped() {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=640px, maximum-scale=1" />
        <title>Set 12 Magic & Mayhem Wrapped - Teamfight Tactics</title>
      </Head>
      <SetWrappedPage />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
